/* eslint-disable no-dupe-keys */
export default {
  evcs_ecmp_order: {
    name: '我方充电设备的订单',
    // 属性（一般与对象内容匹配）
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      id: '订单号',
      ecmp_trade_number: 'ECMP 订单号',
      charging_started_at: '开始充电时间',
      evcs_operator: '第三方',
      service_provider: '运营商',
      charger: '充电桩',
      charging_time: '充电时长',
      consumed_power: '用电量',
      amount: '费用',
      charging_finished_at: '结束充电时间',
      stop_reason: '结束原因',
      start_charge_notify_fail_reason: '启动失败原因',
      status: '状态',
      billing_info: '计费信息',
      notify_result: '推送通知',
      start_charge_notify_fail: '启动通知失败',
      stop_charge_notify_fail: '结束通知失败',
      charge_order_info_notify_fail: '订单通知失败',
      created_at: '创建时间',
      updated_at: '更新时间',
      fail_reason: '失败原因'
    },
    statuses: {
      in_progress: '进行中',
      closed: '已关闭',
      unpaid: '未支付',
      paid: '已支付'
    },
    fail_reasons: {
      connector_not_exist: '设备不存在',
      connector_offline: '设备离线',
      connector_unavailable: '设备不可用',
      duplicated_start_charge_seq: '重复的订单号',
      connector_occupied: '设备被占用'
    },
    notify_fail: {
      true: '是',
      false: '否'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询互联互通订单号'
    },
    notify_result: {
      start_charge_result: '启动通知',
      stop_charge_result: '结束通知',
      charge_order_info: '订单通知'
    },
    modal: {
      title: '重新发送',
      content: '是否重新发送通知？',
      success: '重新发送{0}成功',
      fail_response: '{0}推送失败，因为第三方平台响应结果为 失败',
      fail_request: '{0}推送失败，因为第三方平台请求无法响应'
    },
    tooltip: {
      success: '信息已通过 notification_{0} API 送达第三方平台商',
      fail: '信息无法通过 notification_{0} API 送达第三方平台商，请点击重新发送'
    },
    btn: {
      view_access_log: '查看日志'
    }
  }
}
